import React from "react";
import { CP_PACKAGES, PAYMENT_METHOD } from "../data/packages";
import { ExternalLink, Coins, Lock, ShoppingBag } from "lucide-react";

const formatNum = (n) => new Intl.NumberFormat("en-US").format(n);
const formatSar = (n) =>
  Number.isInteger(n) ? formatNum(n) : n.toFixed(2).replace(/\.?0+$/, "");

const PackageCard = ({ pkg }) => {
  const disabled = !pkg.link;
  return (
    <div
      data-testid={`cp-package-${pkg.cp}`}
      className="group relative rounded-2xl bg-gradient-to-br from-white/[0.05] to-white/[0.01] border border-white/10 hover:border-[#C9A96A]/40 transition-all overflow-hidden flex flex-col"
    >
      {/* Image */}
      <div className="relative aspect-square bg-[#0A1128] flex items-center justify-center p-4">
        <img
          src={pkg.image}
          alt={pkg.name}
          loading="lazy"
          className="w-full h-full object-contain drop-shadow-[0_10px_20px_rgba(201,169,106,0.15)] group-hover:scale-105 transition-transform duration-500"
        />
      </div>

      {/* Body */}
      <div className="p-4 flex-1 flex flex-col gap-3">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-1.5 text-[#E5CB94]">
            <Coins className="w-4 h-4" />
            <span className="font-black text-lg tabular-nums text-white">
              {formatNum(pkg.cp)}
            </span>
            <span className="text-white/60 text-xs font-semibold">CP</span>
          </div>
          <span className="text-[10px] px-2 py-0.5 rounded-full bg-white/[0.04] border border-white/10 text-white/60">
            {PAYMENT_METHOD}
          </span>
        </div>

        <div className="flex items-baseline gap-1 border-t border-white/5 pt-3">
          <span className="text-white/60 text-xs">السعر</span>
          <span className="mr-auto text-white font-black text-2xl tabular-nums">
            {formatSar(pkg.price)}
          </span>
          <span className="text-[#C9A96A] font-bold text-sm">ريال</span>
        </div>

        {disabled ? (
          <button
            type="button"
            disabled
            data-testid={`cp-package-buy-${pkg.cp}`}
            className="mt-auto w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-white/[0.03] border border-white/10 text-white/40 font-bold text-sm cursor-not-allowed"
          >
            <Lock className="w-4 h-4" />
            الرابط سيُضاف قريبًا
          </button>
        ) : (
          <a
            href={pkg.link}
            target="_blank"
            rel="noreferrer"
            data-testid={`cp-package-buy-${pkg.cp}`}
            className="mt-auto w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-gradient-to-b from-[#D4B278] to-[#B08A4A] text-[#0A1128] font-black text-sm hover:brightness-110 transition"
          >
            <ShoppingBag className="w-4 h-4" />
            شراء الآن
            <ExternalLink className="w-3.5 h-3.5 opacity-70" />
          </a>
        )}
      </div>
    </div>
  );
};

const PackagesSection = () => {
  return (
    <section
      id="packages"
      data-testid="cp-packages-section"
      className="max-w-6xl mx-auto px-4 sm:px-6 py-12 sm:py-16"
    >
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#C9A96A]/[0.08] border border-[#C9A96A]/25 text-[#E5CB94] text-[11px] font-bold mb-3">
          <ShoppingBag className="w-3.5 h-3.5" />
          باقات Rush Store الرسمية
        </div>
        <h2 className="text-white text-3xl sm:text-4xl font-black tracking-tight">
          باقات CP الرسمية
        </h2>
        <p className="text-white/50 text-sm sm:text-base mt-2 max-w-xl mx-auto">
          الأسعار موحّدة لجميع أنواع الحسابات (خليجي / متوسط / أفريقي) عبر تحويل
          بنكي.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
        {CP_PACKAGES.map((p) => (
          <PackageCard key={p.id} pkg={p} />
        ))}
      </div>
    </section>
  );
};

export default PackagesSection;
